<template>
    <div>
        <card-header title="User Search" icon="fa-search"/>

        <card-body>
            <card-list>
                <subheader-list-item :title="props.query" icon="fa-search" :badge="searchCount"/>
                <user-tile
                    v-for="user in users"
                    :card="card"
                    :user="user"
                    :active="(child && child.definition.component === 'user' && user.id === parseInt(child.props.userId))"
                    @click="$openCard('user', {userId: user.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SearchListItem from "@/TIER/components/SearchListItem";

    import UserTile from "../../components/tiles/UserTile";

    import {client as http} from '@/http_client';

    export default {
        components: {CardHeader, CardBody, CardList, UserTile, SubheaderListItem, SearchListItem},
        props: ['card', 'child', 'props'],
        data() {
            return {
                users: [],
                count: 0
            };
        },
        methods: {
            searchUsers: function(q) {
                this.$emit('loading', true);
                http.get('users/search/' + this.props.query + '/0/30').then(response => {
                    this.users = response.data.users;
                    this.count = response.data.count;
                    this.$emit('loading', false);
                });
                console.log('us: search users: ' + this.props.query);
            }
        },
        computed: {
            'searchCount': function() {
                return this.users.length + ' ' + (this.users.length === 1 ? 'Result' : 'Results');
            }
        },
        watch: {
            'props.query': function(val) {
                this.searchUsers();
            }
        },
        mounted: function() {
            this.searchUsers();

        }
    };
</script>

<style lang="scss" scoped>

</style>
